import { instance } from "libs/api";

import { ContentPrivacyAndTerms } from "../../content.types";
import { ApiRoutesContent } from "./../../constants";

export const requestUpdatePrivacyAndTerms = async (
  body: ContentPrivacyAndTerms
): Promise<ContentPrivacyAndTerms> => {
  return await instance.post(ApiRoutesContent.PrivacyAndTerms, body);
};
